import React, { FC, useEffect } from 'react'

declare global {
    interface Window {
        yotpo?: {
            refreshWidgets: () => void
            initialized?: boolean
            inview: YotpoInView
        }
    }
}

export type YotpoInView = {
    allWidgetsAreReady: boolean
}

export type YotpoReviewsProps = {
    enabled: boolean
    productId: string
    price: string
    url: string
    currency: string
    name: string
    imageUrl: string
    description: string
}

/**
 * Adds a div to the DOM for Yotpo to embed reviews
 */
export const YotpoReviews: FC<YotpoReviewsProps> = ({
    enabled = false,
    productId,
    price,
    url,
    currency,
    name,
    imageUrl,
    description
}) => {
    useEffect(() => {
        if (enabled && typeof window !== 'undefined' && window.yotpo) {
            window.yotpo.refreshWidgets()
        }

        if (typeof window !== 'undefined') {
            const yotpoWidget = document?.querySelector(
                '.yotpo.yotpo-main-widget'
            )
            if (yotpoWidget) {
                const yotpoResizeObserver = new ResizeObserver((entries) => {
                    const elements = document?.querySelectorAll(
                        '.yotpo-page-element[data-page]'
                    )

                    elements?.forEach((item) => {
                        item.setAttribute(
                            'href',
                            `${url}?yoReviewsPage=${item.getAttribute(
                                'data-page'
                            )}`
                        )
                    })
                })

                yotpoResizeObserver.observe(yotpoWidget)
            }
        }
    }, [])

    if (!enabled) return null

    return (
        <div
            className="yotpo yotpo-main-widget"
            data-product-id={productId}
            data-price={price}
            data-currency={currency}
            data-name={name}
            data-url={url}
            data-image-url={imageUrl}
            data-description={description}
        />
    )
}
